/* src/app/timeline-transport/partals/timeline-transport-main/timeline-transport-main.component.scss */
.timelineBlock {
  width: 15rem;
  height: 6rem;
  padding: 0.4rem;
  margin: 0.2rem;
  background-color: #e2e8f0;
  border: 1px solid #cbd5e1;
  border-radius: 0.35rem;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-right: 5rem;
  overflow: hidden;
  vertical-align: top;
}
.timelineBlock.dragover {
  background-color: pink !important;
}
.timelineBlock .timelineBlockInfo {
  flex: 0 1 auto;
  overflow: hidden;
  font-size: 0.7rem;
  line-height: 1.25;
}
.timelineBlock .timelineBlockInfo .blockDetailLabel {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.75);
}
.timelineBlock .qty {
  background: #1e293b;
  color: white;
  font-weight: bold;
  font-size: 0.7rem;
  position: absolute;
  right: 0;
  top: 0;
  min-width: 2.2rem;
  min-height: 1.5rem;
  text-align: center;
}
.timelineBlock .qty .qtyNo {
  text-align: center;
}
.timelineBlock .timelineBlockAvatar {
  position: absolute;
  left: 0.3rem;
  bottom: 0.3rem;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.7);
}
.timelineBlock .jobStatus {
  background: #006498;
  color: white;
  font-weight: bold;
  font-size: 0.7rem;
  position: absolute;
  right: 0;
  top: 1.5rem;
  min-width: 2.2rem;
  min-height: 1.5rem;
  text-align: center;
}
.timelineBlock .jobStatus .jobStatusName {
  text-align: center;
}
.timelineBlock.allocated {
  background-color: #64748b;
  color: white;
  cursor: pointer;
  transition:
    box-shadow 0.15s ease-out,
    filter 0.15s ease-out,
    opacity 0.15s ease-out;
}
.timelineBlock.allocated:hover {
  filter: brightness(1.08);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.3);
}
.timelineBlock.allocated.statusFilteredOut {
  opacity: 0.35;
}
.timelineBlock.jobInfoActive {
  outline: 2px dashed #006498;
  outline-offset: 2px;
}
.timelineBlock.dragover {
  background-color: pink;
}
.smallBlock {
  width: 8rem;
}
.jobAllocationTable thead th {
  color: #1e293b;
}
.timelineEmptyState {
  background: #f1f5f9;
  border: 1px dashed #cbd5e1;
  border-radius: 0.6rem;
  color: #475569;
  padding: 1.25rem 1.5rem;
  text-align: center;
  font-size: 0.9rem;
}
.timelineEmptyState i {
  display: block;
  font-size: 1.5rem;
  color: #94a3b8;
  margin-bottom: 0.5rem;
}
.timelineSkeleton {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.timelineSkeletonRow {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.timelineSkeletonHeader {
  width: 16rem;
  height: 4rem;
  border-radius: 0.35rem;
  background: #e2e8f0;
  animation: skeletonPulse 1.4s ease-in-out infinite;
}
.timelineSkeletonBlocks {
  display: flex;
  gap: 0.4rem;
}
.timelineSkeletonBlock {
  width: 15rem;
  height: 6rem;
  border-radius: 0.35rem;
  background: #e2e8f0;
  animation: skeletonPulse 1.4s ease-in-out infinite;
}
@keyframes skeletonPulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.infoRow {
  cursor: pointer;
}
.infoRow td {
  padding: 0.5rem 1rem;
  background: #fff7ed;
  border-left: 3px solid #f59e0b;
}
.infoRowLabel {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.7rem;
  margin-right: 0.75rem;
  color: #92400e;
}
.infoRowDetail {
  font-size: 0.8rem;
  color: #1e293b;
}
.jobAllocationTable .time {
  border: 0;
  padding: 0.35rem;
  width: 8rem;
}
.jobAllocationTable td i {
  font-size: 1.3rem;
  color: white;
}
.jobAllocationTable td i:hover {
  color: #16a34a;
  cursor: pointer;
}
.blockContainer {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  width: 17rem;
}
.blockContainer.dragover {
  background-color: pink;
}
.allocationContainer {
  display: flex;
}
.roundHeaderHorizontal {
  color: white;
  border-top: 3px solid #006498;
  padding: 0.4rem 0.5rem;
  background: #1e293b;
  height: 4rem;
  font-size: 0.7rem;
  min-width: 16rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.roundHeaderHorizontal.sub {
  background-color: #b45309;
  border-top: 3px solid #1e293b;
}
.roundHeaderHorizontal .roundHeaderCheckbox {
  flex: 0 0 auto;
}
.roundHeaderHorizontal .roundHeaderMain {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
.roundHeaderHorizontal .roundHeaderActions {
  flex: 0 0 auto;
  display: flex;
  gap: 0.25rem;
}
.roundHeaderHorizontal button {
  padding: 0;
  width: 2.5rem;
  height: 1.5rem;
}
.timelineRoundsContainer {
  font-size: 0.65rem;
  overflow-x: scroll;
}
.timelineRoundsContainer .timelineRound {
  min-height: 50rem;
  min-width: 15rem;
}
.timelineRoundsContainer .timelineRound .roundHeader {
  background-color: #1e293b;
}
.timelineRoundsContainer .timelineRound .roundHeader.sub {
  background-color: #b45309;
  border-top: 3px solid #1e293b;
}
.timelineRoundsContainer .timelineRound .roundHeader {
  color: white;
  border-top: 3px solid #006498;
  padding: 1rem;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.timelineRoundsContainer .timelineRound .roundHeader button {
  width: 3rem;
}
.timelineRoundsContainer .timelineRound .roundContainer {
  margin-top: 0.5rem;
  background-color: white;
  padding: 0.5rem;
  height: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.timelineRoundsContainer .timelineRound .roundContainer.drop {
  background-color: pink;
}
.timelineRoundsContainer .orderContainer {
  background-color: #e2e8f0;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: grab;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
/*# sourceMappingURL=timeline-transport-main.component.css.map */
